import React from "react";
import tw from "twin.macro";
import Layout from "components/yenimahalle/Layout.js";
import ContentHeader from "components/yenimahalle/ContentHeader";
import ContentText from "components/yenimahalle/ContentText";
import RoutingSidebar from "components/yenimahalle/RoutingSidebar";
import AlbumImages from "components/yenimahalle/AlbumImages";

import news1 from "images/yenimahalle/news_1.jpg";
import news2 from "images/yenimahalle/news_2.jpg";
import news3 from "images/yenimahalle/news_3.jpg";
import news4 from "images/yenimahalle/news_4.jpg";
import news5 from "images/yenimahalle/news_5.jpg";

import baskan_1 from "images/yenimahalle/baskan_1.jpg";
import baskan_2 from "images/yenimahalle/baskan_2.jpg";
import baskan_3 from "images/yenimahalle/baskan_3.jpg";
import baskan_4 from "images/yenimahalle/baskan_4.jpg";
import baskan_5 from "images/yenimahalle/baskan_5.jpg";
import baskan_6 from "images/yenimahalle/baskan_6.jpg";
import baskan_7 from "images/yenimahalle/baskan_7.jpg";
import baskan_8 from "images/yenimahalle/baskan_8.jpg";
import baskan_9 from "images/yenimahalle/baskan_9.jpg";
import baskan_10 from "images/yenimahalle/baskan_10.jpg";
import baskan_11 from "images/yenimahalle/baskan_11.jpg";
import baskan_12 from "images/yenimahalle/baskan_12.jpg";
import baskan_13 from "images/yenimahalle/baskan_13.jpg";
import baskan_14 from "images/yenimahalle/baskan_14.jpg";
import baskan_15 from "images/yenimahalle/baskan_15.jpg";
import baskan_16 from "images/yenimahalle/baskan_16.jpg";
import baskan_17 from "images/yenimahalle/baskan_17.jpg";
import baskan_18 from "images/yenimahalle/baskan_18.jpg";
import baskan_19 from "images/yenimahalle/baskan_19.jpg";

const otherNews = [
  {
    imageSrc: news1,
    title: `Mahalle iftarları Demetevler’den start aldı`,
    buttonLink: `/haber-1`
  },
  {
    imageSrc: news2,
    title: `"Haybeden Gerçeküstü Aşk" Yenimahalle’de Sahnelendi`,
    buttonLink: `/haber-2`
  },
  {
    imageSrc: news3,
    title: `Yenimahalleliler, Obezite Hakkına Bilgilendirildi`,
    buttonLink: `/haber-3`
  },
  {
    imageSrc: news4,
    title: `“İstanbul’un En Güzel Kızı” Yenimahalle’de`,
    buttonLink: `/haber-4`
  },
  {
    imageSrc: news5,
    title: `Yenimahalle’de Ramazan Denetimi`,
    buttonLink: `/haber-5`
  }
];

const albumImages = [
  baskan_1,
  baskan_2,
  baskan_3,
  baskan_4,
  baskan_5,
  baskan_6,
  baskan_7,
  baskan_8,
  baskan_9,
  baskan_10,
  baskan_11,
  baskan_12,
  baskan_13,
  baskan_14,
  baskan_15,
  baskan_16,
  baskan_17,
  baskan_18,
  baskan_19
];

const NewsContentContainer = tw.div`
  pt-8 pb-16 px-4
  flex flex-col lg:flex-row
  justify-between items-start
  max-w-screen-xl mx-auto
`;

const LeftColumn = tw.div`
  w-full lg:w-9/12
`;
const RightColumn = tw.div`
  w-full lg:w-3/12 mt-8 lg:mt-0
`;

const Heading = tw.span`
inline-block my-4 pl-3 py-1 text-xl font-bold border-l-4 border-primary-500
`;

export default function YenimahalleNewsDetails() {
  return (
    <Layout>
      <ContentHeader
        headingLine1="Haber başlığı 1"
        headingLine2="Haber başlığı 2"
        topNotification="Üst metin buraya gelecek."
        bottomNotification="Alt metin ise buraya gelecek."
        primaryButtonUrl="https://yenimahalle.bel.tr"
        primaryButtonText="Yenimahalle"
        secondaryButtonUrl="https://albinasoft.com"
        secondaryButtonText="Albinasoft"
        photoUrl="https://www.yenimahalle.bel.tr/Dosyalar/HaberResimleri/14_d2c711ec-59e8-49f0-8db3-ccafa14ba672.jpg"
        videoUrl="https://www.youtube.com/embed/i_vXSL1eGxE"
      />
      <NewsContentContainer>
        {/* Sol Kolon: Haber metni */}
        <LeftColumn>
          <ContentText htmlContent={`
            <p>Vatandaşlar 75 dakikalık tek perdelik oyunu izlemek için saatler öncesinden salonu tıklım tıklım doldurdu.</p>
            <p><strong>İzleyenleri kahkahaya boğdu</strong></p>
            <p>Kadın erkek ilişkisinin konu alındığı komedi oyununda, günümüz ilişkileri mizahi bir dille ele alındı. Oyuncular, trajikomik anlarla izleyenleri kahkahaya boğdu. Unutulmaz bir deneyim sunan oyunda, eğlence tavan yaptı.</p>
            <p>Vatandaşlardan büyük beğeni toplayan oyunda, düşünenlerini dile getiren Yenimahalleli Serkan Kıraç, “Tiyatro Festivali kapsamında birkaç oyunu izleme fırsatı buldum. Ücretsiz olması ayrıca bizleri memnun ediyor. Birbirinden ünlü isimleri görme fırsatımız oldu. Yenimahalle Belediye Başkanı Fethi Yaşar’a ve ekibine teşekkür ediyorum. Yenimahalle’de yaşamak gerçekten bir ayrıcalık” dedi.</p>
          `} />
          <Heading>
            Foto Galeri
          </Heading>
          <AlbumImages
            images={albumImages}
          />
        </LeftColumn>
        {/* Sağ Kolon: Diğer Haberler */}
        <RightColumn>
          <RoutingSidebar
            heading="Diğer Haberler"
            cards={otherNews}
          />
        </RightColumn>
      </NewsContentContainer>
    </Layout>
  );
}
